import { buildModelManager } from "../builder.js";
const DefaultApprenticeMessageSelection = {
  __typename: true,
  id: true,
  content: true,
  conversationId: true,
  createdAt: true,
  profileId: true,
  role: true,
  toolCalls: true,
  toolName: true,
  toolPayload: true,
  updatedAt: true
};
const modelApiIdentifier = "apprenticeMessage";
const pluralModelApiIdentifier = "apprenticeMessages";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultApprenticeMessageSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultApprenticeMessageSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultApprenticeMessageSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultApprenticeMessageSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultApprenticeMessageSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultApprenticeMessageSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultApprenticeMessageSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "apprenticeMessageGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ApprenticeMessageManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultApprenticeMessageSelection,
  operations
);
export {
  ApprenticeMessageManager,
  DefaultApprenticeMessageSelection
};
//# sourceMappingURL=ApprenticeMessage.js.map
